import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import BackEnd from "../../../../backend/BackEnd";

class ConfigModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        isLoading: false,
        configParameters: []
    };
    getConfigParameters = new BackEnd.SystemOverview.GetConfigParameters(this);

    async componentWillReceiveProps({show}) {
        if (show && this.props.show !== show) {
            let configParameters = await this.getConfigParameters.call();

            this.setState({configParameters});
        }
    }

    render() {
        const props = this.props;
        return (
            <Modal {...props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Параметры конфигурации</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table class={`table table-bordered ${this.state.isLoading ? 'form-loading' : ''}`}>
                        <thead>
                        <tr>
                            <th>ПАРАМЕТР</th>
                            <th>ЗНАЧЕНИЕ</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.configParameters.map(cp =>
                            <tr>
                                <th scope="row">{cp.name}</th>
                                <td>{cp.value}</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </Modal.Body>
            </Modal>
        );
    }
}

export default ConfigModal;


// WEBPACK FOOTER //
// ./src/pages/Developers/SystemOverview/modals/ConfigModal.js